export default __webpack_public_path__ + "static/media/blog-paver-manufacturers-002.8cfbdff0.jpg";